export default {
  regular: 'regular',
  paymentPlan: 'paymentplan',
};
